import React from 'react'

const Warning = ({color}) => {
  return (
    <svg viewBox="0 0 65 65">
      <path fill={color} d="M53,55H12c-1.1,0-2-0.9-2-2V12c0-1.1,0.9-2,2-2H53c1.1,0,2,0.9,2,2V53C55,54.1,54.1,55,53,55z M14.1,50.9h36.8
	V14.1H14.1V50.9z"/>
      <path fill={color} d="M32.5,36.6c-1.1,0-2-0.9-2-2V22.3c0-1.1,0.9-2,2-2s2,0.9,2,2v12.3C34.5,35.7,33.6,36.6,32.5,36.6z"/>
      <circle id="Oval" fill={color} cx="32.5" cy="42.7" r="4.1"/>
    </svg>
  )
}

export default Warning
